import React from "react";
import { useHistory } from "react-router-dom";

import { Box, Typography, Stack, Grid } from "@mui/material";

import {
  AutoAwesome as SparkleIcon,
  Bolt as InstantIcon,
  CheckCircle as VerifiedIcon,
  AddCircleOutline as AddIcon,
} from "@mui/icons-material";

import { borderRadiusPx } from "../../../../../theme";
import { CommonChip, CommonButton } from "../../../../Components/ui";
import { Path, DEFAULT_CURRENCY } from "../../../../../static/Constants";

const SlotHeroBanner = ({
  totalActive = 0,
  combinedPrize = "0.00",
  currency = DEFAULT_CURRENCY || "POL",
}) => {
  const history = useHistory();
  return (
    <Box sx={{ mb: 4 }}>
      <Box className="slot-hero-banner" sx={{ p: { xs: 3, md: 4 } }}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={7}>
            <Stack
              direction="row"
              alignItems="center"
              spacing={1.5}
              sx={{ mb: 1.5 }}
            >
              <Box
                sx={{
                  position: "relative",
                  width: 44,
                  height: 44,
                  borderRadius: borderRadiusPx.md,
                  bgcolor: "rgba(234, 179, 8, 0.15)",
                  border: "1.5px solid rgba(234, 179, 8, 0.5)",
                  boxShadow: "0 2px 8px rgba(234, 179, 8, 0.25)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                }}
              >
                <Typography
                  sx={{
                    position: "absolute",
                    left: 6,
                    top: 8,
                    fontSize: "1.35rem",
                    lineHeight: 1,
                    fontWeight: 900,
                    color: "#f59e0b",
                    transform: "rotate(-14deg)",
                    opacity: 0.45,
                    zIndex: 1,
                    userSelect: "none",
                  }}
                >
                  7
                </Typography>

                <Typography
                  sx={{
                    position: "absolute",
                    left: "50%",
                    top: "50%",
                    transform: "translate(-50%, -50%)",
                    fontSize: "1.65rem",
                    lineHeight: 1,
                    fontWeight: 900,
                    color: "#fde047",
                    zIndex: 3,
                    userSelect: "none",
                    filter: "drop-shadow(0 0 6px rgba(250, 204, 21, 0.6))",
                  }}
                >
                  7
                </Typography>

                <Typography
                  sx={{
                    position: "absolute",
                    right: 6,
                    top: 8,
                    fontSize: "1.35rem",
                    lineHeight: 1,
                    fontWeight: 900,
                    color: "#f59e0b",
                    transform: "rotate(14deg)",
                    opacity: 0.45,
                    zIndex: 1,
                    userSelect: "none",
                  }}
                >
                  7
                </Typography>
              </Box>

              <Box>
                <Typography
                  variant="overline"
                  sx={{
                    color: "#f59e0b",
                    fontWeight: 800,
                    letterSpacing: 1.2,
                  }}
                >
                  LIVE ARENA
                </Typography>

                <Typography variant="h4" className="slot-hero-title">
                  3-SlotBET
                </Typography>
              </Box>
            </Stack>

            <Typography
              variant="body1"
              sx={{
                color: "#e2e8f0",
                maxWidth: 520,
                lineHeight: 1.6,
                fontWeight: 500,
                fontSize: "0.95rem",
                mb: 2,
              }}
            >
              Spin the reels, match the symbols and win progressive jackpots.
              Simple gameplay with transparent on-chain results.
            </Typography>

            <Stack direction="row" gap={1.5} flexWrap="wrap" sx={{ gap: 1 }}>
              <CommonChip
                icon={<InstantIcon sx={{ fontSize: 16 }} />}
                label="3-Reel Slot"
                variant="neutral"
                size="small"
                backgroundColor="rgba(30, 41, 59, 0.8)"
                color="#e2e8f0"
                sx={{ border: "1px solid rgba(234, 179, 8, 0.3)" }}
              />

              <CommonChip
                icon={<SparkleIcon sx={{ fontSize: 15 }} />}
                label="Progressive Jackpot"
                variant="neutral"
                size="small"
                backgroundColor="rgba(30, 41, 59, 0.8)"
                color="#fef08a"
                sx={{ border: "1px solid rgba(234, 179, 8, 0.3)" }}
              />

              <CommonChip
                icon={<VerifiedIcon sx={{ fontSize: 15 }} />}
                label="On-Chain Results"
                variant="neutral"
                size="small"
                backgroundColor="rgba(30, 41, 59, 0.8)"
                color="#4ade80"
                sx={{ border: "1px solid rgba(234, 179, 8, 0.3)" }}
              />
            </Stack>
          </Grid>

          <Grid item xs={12} md={5}>
            <Stack
              direction={{
                xs: "column",
                sm: "row",
              }}
              spacing={2}
              justifyContent={{ md: "flex-end" }}
            >
              <Box className="slot-stat-card" sx={{ minWidth: 140 }}>
                <Typography
                  variant="caption"
                  sx={{
                    color: "#94a3b8",
                    fontWeight: 700,
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    display: "block",
                  }}
                >
                  Active Slots
                </Typography>

                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 900,
                    color: "#ffffff",
                    my: 0.25,
                    fontFamily: "monospace",
                  }}
                >
                  {totalActive}
                </Typography>

                <Typography
                  variant="caption"
                  sx={{
                    color: "#4ade80",
                    fontWeight: 700,
                  }}
                >
                  Ready to Play
                </Typography>
              </Box>

              <Box className="slot-stat-card" sx={{ minWidth: 160 }}>
                <Typography
                  variant="caption"
                  sx={{
                    color: "#94a3b8",
                    fontWeight: 700,
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    display: "block",
                  }}
                >
                  Total Jackpot
                </Typography>

                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 900,
                    color: "#fef08a",
                    my: 0.25,
                    fontFamily: "monospace",
                  }}
                >
                  {combinedPrize}{" "}
                  <Box
                    component="span"
                    sx={{
                      fontSize: "1rem",
                      fontWeight: 800,
                      color: "#ffffff",
                    }}
                  >
                    {currency}
                  </Box>
                </Typography>

                <Typography
                  variant="caption"
                  sx={{
                    color: "#94a3b8",
                    fontWeight: 600,
                  }}
                >
                  Across all slots
                </Typography>
              </Box>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default SlotHeroBanner;
